import { Component } from '@angular/core';

@Component({
    template: `
    <soft-combo-box id="combobox" [value]="'default'">
      <soft-combo-box-option [value]="'Test 1'"></soft-combo-box-option>
      <soft-combo-box-option [value]="'Test 2'"></soft-combo-box-option>
      <soft-combo-box-option [value]="'Test 3'"></soft-combo-box-option>
    </soft-combo-box>
  `,
    standalone: false
})
export class TestWrapperComponent {}
